import CompaniesDispatcher from '@reducers/companies/dispatcher';
import { mapSearchCompanyToCompany } from '@reducers/companies/mappers';
import ContactsDispatcher from '@reducers/contacts/dispatcher';
import { getContactMapKey, mapSearchContactToContact } from '@reducers/contacts/mappers';
import _ from 'lodash';
import { SEARCH_STATUS } from '../../utils/constants';
import { actions } from './reducer';
const normalizeCompanies = (companies) => {
    if (!companies) {
        return [];
    }
    return Array.isArray(companies) ? companies : Object.values(companies);
};
const getContactCompanyLid = (contact) => {
    var _a, _b;
    const snakeLid = contact.company_lid;
    return (_b = (_a = contact.companyLid) !== null && _a !== void 0 ? _a : snakeLid) !== null && _b !== void 0 ? _b : null;
};
const resolveCompanyName = (contact, companies) => {
    const companyLid = getContactCompanyLid(contact);
    if (companyLid == null) {
        return '';
    }
    const company = companies.find(item => item.company_lid != null && Number(item.company_lid) === Number(companyLid));
    return (company === null || company === void 0 ? void 0 : company.name) || '';
};
class Dispatcher {
    constructor() {
        this.actions = actions;
    }
    setSearchResult(result) {
        return dispatch => {
            var _a, _b;
            const { metadata } = result || {};
            const companies = normalizeCompanies(result === null || result === void 0 ? void 0 : result.companies);
            const contacts = _.map(result === null || result === void 0 ? void 0 : result.contacts, contact => mapSearchContactToContact(contact, {
                requestId: metadata === null || metadata === void 0 ? void 0 : metadata.requestId,
                maskedId: (metadata === null || metadata === void 0 ? void 0 : metadata.maskId) || (metadata === null || metadata === void 0 ? void 0 : metadata.maskedId) || null,
                companyLid: getContactCompanyLid(contact),
                companyName: resolveCompanyName(contact, companies),
            }));
            const contactIds = contacts.map(contact => getContactMapKey(contact)).filter(Boolean);
            const mappedCompanies = companies
                .map(mapSearchCompanyToCompany)
                .filter((company) => Boolean(company));
            dispatch(actions.setSearchResult({
                contactIds,
                companies,
                requestId: (metadata === null || metadata === void 0 ? void 0 : metadata.requestId) || '',
                uniqueSearchId: (metadata === null || metadata === void 0 ? void 0 : metadata.uniqueSearchId) || ((_b = (_a = result === null || result === void 0 ? void 0 : result.contacts) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.uniqueSearchId) || '',
                sessionId: (metadata === null || metadata === void 0 ? void 0 : metadata.sessionId) || '',
                maskedId: (metadata === null || metadata === void 0 ? void 0 : metadata.maskId) || (metadata === null || metadata === void 0 ? void 0 : metadata.maskedId) || '',
            }));
            if (mappedCompanies.length) {
                dispatch(CompaniesDispatcher.setCompanies(mappedCompanies));
            }
            if (!_.isEmpty(contacts)) {
                dispatch(ContactsDispatcher.setContacts(contacts));
            }
        };
    }
    setSearchStatus(status) {
        return dispatch => {
            dispatch(actions.setSearchStatus(status));
        };
    }
    setFilters(filters) {
        return dispatch => {
            dispatch(actions.setFilters(filters));
        };
    }
    setShowCreditSplitPopup(isOpen, creditSplitErrorType) {
        return dispatch => {
            dispatch(actions.setShowCreditSplitPopup({
                isOpen: Boolean(isOpen),
                creditSplitErrorType: typeof creditSplitErrorType === 'string' ? creditSplitErrorType : '',
            }));
        };
    }
    setSelectedDataPointType(selectedDataPointType) {
        return dispatch => {
            dispatch(actions.setSelectedDataPointType(selectedDataPointType == null ? '' : String(selectedDataPointType)));
        };
    }
    startSearch() {
        return dispatch => {
            dispatch(actions.clearSearchResult());
            dispatch(actions.setSearchStatus(SEARCH_STATUS.SEARCHING));
        };
    }
    clearSearchResult() {
        return dispatch => {
            dispatch(actions.clearSearchResult());
        };
    }
}
const BulkDispatcher = new Dispatcher();
export default BulkDispatcher;
